import { authPut } from "@api";

import { PolicyRuleOverride, PolicyWithRules } from "@pages/policy/types";

type OverridesRequestBody = {
  overrides: PolicyRuleOverride[];
};

export const savePolicyRuleOverrides = (
  deploymentId: string,
  policy: PolicyWithRules
): Promise<PolicyWithRules> => {
  const path = `/api/agent/deployments/${deploymentId}/policies/${policy.slug}/overrides`;
  return authPut<OverridesRequestBody, PolicyWithRules>(path, {
    overrides: policy.overrides,
  });
};
